import Base from '../base';
import { initializeSelect2 } from '../../packs/select2Utils';

export default class Index extends Base {
    load() {
        initializeSelect2();
    }
}